<template>
  <div class="container">
    <!--UPLOAD-->
    <v-alert
      v-model="alert"
      border="left"
      close-text="Lukk"
      type="error"
      color="red"
      dismissible
    >
      Det skjedde en feil ved opplasting av bilde. Vennligst sørg for at du er koblet til internett og forsøk på nytt.
    </v-alert>
    <form enctype="multipart/form-data" novalidate>
      <div class="dropbox" v-if="$store.state.online">
        <input type="file" multiple :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
          accept="image/*" class="input-file">
          <p>
            Last opp bilder <br />
            <v-icon x-large color="primary" class="mt-3">mdi-cloud-upload-outline</v-icon>
          </p>
      </div>
      <div class="dropbox" v-else>
        <p color="red">
          <v-icon x-large color="red" class="mt-3">mdi-alert</v-icon><br >Du er ikke koblet til internett og kan derfor ikke laste opp bilder. <br />For å ta bilder, kan du åpne kamera-appen på din telefon, og laste opp bilder når nettforbindelsen er tilbake.
        </p>
      </div>
    </form>
  </div>
</template>


<script>
  import { upload } from './file-upload.service';
  import  ImageHolder  from '../../models/image';

  const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

  export default {
    name: 'app',
    data() {
      return {
        alert: false,
        uploadedFiles: [],
        uploadError: null,
        currentStatus: null,
        uploadFieldName: 'photo',
        currentPhoto: new ImageHolder()
      }
    },
    computed: {
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      }
    },
    methods: {
      reset() {
        // reset form to initial state
        this.currentStatus = STATUS_INITIAL;
        this.uploadedFiles = [];
        this.uploadError = null;
      },
      save(formData, photo) {
        // upload data to the server
        //this.currentStatus = STATUS_SAVING;
        this.alert = false;

        upload(this.$route.params.protocolHash, formData)
          .then(x => {
            photo.public_id = x.public_id;
            photo.base64 = null;
            this.$emit('image-updated', photo);
            //this.currentStatus = STATUS_INITIAL;
          })
          .catch(err => {
            this.uploadError = err.response;
            this.alert = true;
            //this.currentStatus = STATUS_FAILED;
          });
      },
      filesChange(fieldName, fileList) {
        // handle file changes
        if (!fileList.length) return;
        for(var i = 0; i < fileList.length; i++) {
          let file = fileList[i]
          let photo = new ImageHolder();
          const formData = new FormData();
          // append the files to FormData
          var reader = new FileReader();
          reader.onload = (event) => {
            this.resizeBase64Img(event.target.result, 70, 39).then((result)=>{
              photo.base64 = result;
              this.$emit("new-image", photo);
            });
          }
          reader.readAsDataURL(file);
          formData.append(fieldName, file, file.name);

          // save it
          this.save(formData, photo);
        }
      },
      resizeBase64Img(base64, newWidth, newHeight) {
        return new Promise((resolve, reject)=>{
            var canvas = document.createElement("canvas");
            canvas.style.width = newWidth.toString()+"px";
            canvas.style.height = newHeight.toString()+"px";
            let context = canvas.getContext("2d");
            let img = document.createElement("img");
            img.src = base64;
            img.onload = function () {
                context.scale(newWidth/img.width,  newHeight/img.height);
                context.drawImage(img, 0, 0); 
                resolve(canvas.toDataURL());               
            }
        });
      }
    },
    mounted() {
      this.reset();
    },
  }

</script>

<style lang="scss" scoped>
  .dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: transparent;
    color: darkgrey;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background-color:rgba(54, 51, 51, 0.3);
  }

  .dropbox p {
    font-size: 1.4em;
    text-align: center;
    padding: 50px 0;
  }
</style>